module.exports = __webpack_public_path__ + "img/img-1.abb65130.png";